import { render, staticRenderFns } from "./ExchangeRateDialogue.vue?vue&type=template&id=08fd88e4&"
import script from "./ExchangeRateDialogue.vue?vue&type=script&lang=ts&"
export * from "./ExchangeRateDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports